export default "__VITE_ASSET__RyZe1C9Q__"